import { ReactComponent as IconEmoteSad } from "@common_assets/svg/emote-sad.svg"
import { ReactComponent as IconStar } from "@common_assets/svg/star-outlined.svg"
import { ReactComponent as IconUser } from "@common_assets/svg/user-solid.svg"
import { Box } from "@mui/material"
import { useQueryAdminDashboardStudentKpi } from "api/reactQuery/queries/adminDashboard"
import { useTranslation } from "react-i18next"
import {
  IDashboardPeriodParams,
  IDashboardStudentKpi,
} from "ts/interfaces/AdminDashboard"

import { getBonusEarnedShare } from "./dashboardFormat"
import DashboardKpiCard from "./DashboardKpiCard"
import DashboardSectionBody from "./DashboardSectionBody"
import { KpiSkeleton, kpiGridSx } from "./TeachersKpiSummary"

const formatCount = (value: number) => value.toLocaleString("en-US")
const formatPercent = (value: number | null) =>
  value === null ? "—" : `${Math.round(value * 100)}%`

const KpiCards = ({ kpi }: { kpi: IDashboardStudentKpi }) => {
  const { t } = useTranslation()

  return (
    <Box sx={kpiGridSx}>
      <DashboardKpiCard
        accent="mockup.primary60"
        icon={<IconUser width={20} height={20} />}
        iconGap={3}
        iconBgColor="mockup.primary90"
        iconColor="mockup.primary60"
        value={formatCount(kpi.active_students)}
        label={t("adminDashboard.students")}
      />
      <DashboardKpiCard
        accent="mockup.success50"
        icon={<IconStar width={24} height={24} />}
        iconGap={3}
        iconBgColor="mockup.success90"
        iconColor="mockup.success40"
        value={formatPercent(
          getBonusEarnedShare(
            kpi.active_students,
            kpi.students_without_bonuses,
          ),
        )}
        label={t("adminDashboard.earnedBonusThisPeriod")}
      />
      <DashboardKpiCard
        accent="mockup.error50"
        icon={<IconEmoteSad width={24} height={24} />}
        iconGap={3}
        iconBgColor="mockup.error90"
        iconColor="mockup.error30"
        value={formatCount(kpi.students_without_bonuses)}
        label={t("adminDashboard.noBonusesThisPeriod")}
      />
    </Box>
  )
}

const StudentsKpiSummary = ({ params }: { params: IDashboardPeriodParams }) => {
  const query = useQueryAdminDashboardStudentKpi(params)
  const kpi = query.data?.data

  return (
    <DashboardSectionBody queries={[query]} skeleton={<KpiSkeleton />}>
      {kpi && <KpiCards kpi={kpi} />}
    </DashboardSectionBody>
  )
}

export default StudentsKpiSummary
